import { GraphModel } from './graph.model';
import { z } from 'zod/v3';
import { ok } from 'neverthrow';
import {
  ActionResult,
  ApplicableContext,
  ExecuteContext,
  BaseAction,
} from '../actions/framework';
import { Assert } from '@cotera/utilities';
import { GRAPH_ACTION_GROUP } from '../dataset/actions/constants';

type Params = {};

export class DisableAutoPublishAction extends BaseAction<
  Params,
  { t: string; message?: string }[]
> {
  title = 'Disable Auto Publish';
  description = 'Disable auto publish';
  inputSchema = z.object({});
  group = GRAPH_ACTION_GROUP;
  icon = 'publish';

  applicable(context: ApplicableContext): boolean {
    const model = context.getInScopeModelOfType(GraphModel);
    return model !== null && model.autoPublish.snapshot();
  }

  async execute(
    _: Params,
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string; message?: string }[]>> {
    const graph = context.getInScopeModelOfType(GraphModel);

    Assert.assert(graph !== null, 'Graph model not found');

    await graph.setAutoPublish(false);

    return ok({});
  }
}

export class EnableAutoPublishAction extends BaseAction<
  Params,
  { t: string; message?: string }[]
> {
  title = 'Enable Auto Publish';
  description = 'Enable auto publish';
  inputSchema = z.object({});
  group = GRAPH_ACTION_GROUP;
  icon = 'publish';

  applicable(context: ApplicableContext): boolean {
    const model = context.getInScopeModelOfType(GraphModel);
    return model !== null && !model.autoPublish.snapshot();
  }

  async execute(
    _: Params,
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string; message?: string }[]>> {
    const graph = context.getInScopeModelOfType(GraphModel);

    Assert.assert(graph !== null, 'Graph model not found');

    await graph.setAutoPublish(true);

    return ok({});
  }
}
